import { sortHelper } from '@helpers/misc/sortHelper'

const ROLES_COLUMNS_INFO = [
    {
        title: 'Role Name',
        dataIndex: 'name',
        sorter: (a: [], b: []) => sortHelper(a, b, 'name'),
        key: 'name',
    },
    {
        title: 'Role Type',
        dataIndex: 'type',
        sorter: (a: [], b: []) => sortHelper(a, b, 'type'),
        key: 'type',
    },
    {
        title: 'Users',
        dataIndex: 'noOfUsers',
        sorter: (a: [], b: []) => sortHelper(a, b, 'noOfUsers'),
        key: 'noOfUsers',
    },
]

export default ROLES_COLUMNS_INFO